export default "__VITE_ASSET__BkOpyiq3__"